import { memo } from "react";
import { FooterWrapper, SitesGroup, Site } from "./style";

const Footer = memo(() => {
  return (
    <FooterWrapper>
      <p>&copy; {new Date().getFullYear()} Profile Card Maker @ghoon99</p>
      <SitesGroup>
        <Site
          className="github"
          target="_blank"
          rel="noreferrer"
          href="https://github.com/GHooN99"
        >
          Github
        </Site>
        <Site
          className="blog"
          target="_blank"
          rel="noreferrer"
          href="https://ghoon99.tistory.com/"
        >
          Blog
        </Site>
      </SitesGroup>
    </FooterWrapper>
  );
});

export default Footer;
